module.exports = __webpack_public_path__ + "static/media/jetro817_logo.9dc3aa46.png";